import React, { useState, useEffect } from 'react';
import './AdvAllStepCss/DateTimeStep.css';
import { ServiceTiming } from '../../../api/api';


const DateTimeStep = ({
  onNext,
  onBack,
  seletedBranchList,
  deptId,
  departmentWiseServices,
  selectedServicesData,
   allServiceTiming,
  onFetchServiceTiming,
  chooseDoctor,
  setChooseDoctor,
  // ad
}) => {
  const [dateTime, setDateTime] = useState({
    date: "",
    day: "",
    dayNumber: "",
    time: ""
  });
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const[AllServiceTiming,setAllServiceTiming] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  // const [chooseDoctor,setChooseDoctor] = useState([]);
  console.log("Received branchesList in DateTime:", seletedBranchList);
  console.log("Received deptId in DateTime:", deptId);
  console.log("selectedServicesData======> in DATE_TIME_STEP",selectedServicesData);

  


  const getNext7Days = () => {
    const result = [];
    const today = new Date();
    for (let i = 1; i <= 7; i++) {
      const date = new Date(today); 
      date.setDate(today.getDate() + i);
      const formattedDate = date.toLocaleDateString('en-GB'); // DD/MM/YYYY
      const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
      const dayNumber = date.getDay() === 0 ? 7 : date.getDay(); // ADD THIS LINE
      result.push({
        date: formattedDate.replaceAll('/', '-'), // 29-12-2025
        day: dayName,
        dayNumber: dayNumber
      });
    }
    return result;
  };

  const dates = getNext7Days();
  // const timeSlots = ['09:00 AM', '10:00 AM', '11:00 AM', '02:00 PM', '03:00 PM', '04:00 PM'];
  const handleDateChange = (selected) => {
    setDateTime(prev => ({
      ...prev,
      date: selected.date,
      day: selected.day,
      dayNumber: selected.dayNumber
    }));
  };

  const handleTimeChange = (time) => {
    setDateTime(prev => ({
      ...prev,
      time: time
    }));
  };

  const onCenterChange = (center) => {
    setSelectedCenter(center);
  };

  // Auto select first date, time, and center
  useEffect(() => {
    if (!dateTime.date && dates.length > 0) {
      handleDateChange(dates[0]);
    }
    if (!dateTime.time && timeSlots.length > 0) {
      handleTimeChange(timeSlots[0]);
    }
    if (!selectedCenter && seletedBranchList.length > 0) {
      setSelectedCenter(seletedBranchList[0]);
    }
  }, [seletedBranchList]);

  console.log("selected dateTime is ====>", dateTime);
  console.log("selected center is ====>", selectedCenter);

  // call service Timing api 
// call service Timing api 
useEffect(() => {
  console.log("API Effect triggered with:", {
    dayNumber: dateTime.dayNumber,
    branchID: selectedCenter?.BranchID,
    deptId: deptId
  });
  
  if (dateTime.dayNumber && selectedCenter?.BranchID && deptId) {
    console.log("✅ All conditions met, calling API");
    fetchServiceTiming();
  }
}, [dateTime.dayNumber, selectedCenter?.BranchID, deptId]);

const fetchServiceTiming = async () => {
  const payload = {
    RBAuthKey: "RBDWAh!Q1s74e",
    DeptID: deptId,
    branchid:  selectedCenter?.BranchID,
    // selectedCenter?.BranchID 
    Day: dateTime?.dayNumber
  }
  console.log("🚀 API Payload ====>", payload); // Fixed - log payload not function
  
  try {
    setLoading(true);
    const res = await ServiceTiming(payload);
    console.log("📥 API Response ====>", res); // Add this
    
    if (res?.data?.status === "success") {
      const apiData = res?.data?.data || [];
      console.log("📊 API Data ====>", apiData); // Add this
      
      if (apiData.length > 0) {
        setAllServiceTiming(apiData);
        console.log("✅ setAllServiceTiming response ====>", apiData);
        setMessage("");
      } else {
        setAllServiceTiming([]);
        setMessage("No data found");
        console.log("⚠️ No data found in response");
      }
    } else {
      console.log("❌ API status not success:", res?.data);
      setMessage("Problem on API");
      setAllServiceTiming([]);
    }
  } catch (error) {
    console.error("💥 Error fetching service timing:", error);
    setMessage("Something went wrong");
    setAllServiceTiming([]);
  } finally {
    setLoading(false);
  }
};

// new item 
// Helper Function for time slots 
const timeToMinutesForTimeSlot = (timeStr) => {
  const [time, period] = timeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);
  
  if (period === 'PM' && hours !== 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }
  
  return hours * 60 + minutes;
};

const minutesToTime = (totalMinutes) => {
  let hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const period = hours >= 12 ? 'PM' : 'AM';
  
  if (hours > 12) {
    hours -= 12;
  } else if (hours === 0) {
    hours = 12;
  }
  
  const formattedMinutes = minutes.toString().padStart(2, '0');
  return `${hours}:${formattedMinutes} ${period}`;
};

const generateTimeSlots = (AllServiceTiming, selectedServicesData) => {
  console.log("🕒 generateTimeSlots called");
  
  if (!AllServiceTiming || AllServiceTiming.length === 0) {
    console.warn("⚠️ AllServiceTiming is empty");
    return [];
  }

  if (!selectedServicesData || selectedServicesData.length === 0) {
    console.warn("⚠️ selectedServicesData is empty");
    return [];
  }

  // Get service duration
  const serviceDuration = selectedServicesData.reduce((max, service) => {
    return Math.max(max, service.Service_TimeTaken_Mins || 0);
  }, 0);

  console.log("⏱️ Service duration:", serviceDuration, "minutes");

  if (serviceDuration === 0) {
    console.error("❌ Service duration is 0");
    return [];
  }

  // Generate slots for each timing block
  const allSlots = [];
  
  AllServiceTiming.forEach((timing, index) => {
    console.log(`Processing timing block ${index + 1}:`, timing);
    
    const fromTime = timing.FromTime;
    const toTime = timing.ToTime;
    
    try {
      const startMinutes = timeToMinutesForTimeSlot(fromTime);
      let endMinutes = timeToMinutesForTimeSlot(toTime);
      
      // Handle case where ToTime is before FromTime (AM/PM issue)
      if (endMinutes < startMinutes) {
        endMinutes = endMinutes + 12 * 60;
      }
      
      let currentMinutes = startMinutes;
      
      while (currentMinutes + serviceDuration <= endMinutes) {
        const slotTime = minutesToTime(currentMinutes);
        if (!allSlots.includes(slotTime)) {
          allSlots.push(slotTime);
        }
        currentMinutes += serviceDuration;
      }
    } catch (error) {
      console.error(`Error processing timing block ${index + 1}:`, error);
    }
  });
  
  // Sort slots chronologically
  allSlots.sort((a, b) => timeToMinutesForTimeSlot(a) - timeToMinutesForTimeSlot(b));
  
  console.log("✅ Final generated slots:", allSlots);
  return allSlots;
};

// 
// New Added
// Generate time slots when data is available
useEffect(() => {
  console.log("🔄 Time slot generation effect triggered");
  
  if (AllServiceTiming.length > 0 && selectedServicesData?.length > 0) {
    console.log("🕒 Generating time slots...");
    const generatedSlots = generateTimeSlots(AllServiceTiming, selectedServicesData);
    console.log("✅ Generated time slots:", generatedSlots);
    setTimeSlots(generatedSlots);
    
    // Auto-select first time slot if needed
    if (generatedSlots.length > 0 && !generatedSlots.includes(dateTime.time)) {
      handleTimeChange(generatedSlots[0]);
    }
  } else {
    console.warn("⚠️ Cannot generate slots - missing data");
    setTimeSlots([]);
  }
}, [AllServiceTiming, selectedServicesData]); 
// complete 
//  -----------to select test doctor ----------
function timeToMinutes(timeStr) {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return hours * 60 + minutes;
}

function getDoctorsByTime(doctors, selectedTime) {
  const selectedMinutes = timeToMinutes(selectedTime);

  return doctors.filter((doc) => {
    const fromMinutes = timeToMinutes(doc.FromTime);
    let toMinutes = timeToMinutes(doc.ToTime);

    // 🔥 HANDLE OVERNIGHT SLOT (e.g. 10:00 AM → 12:00 AM)
    if (toMinutes <= fromMinutes) {
      toMinutes += 24 * 60;
    }

    // 🔥 ADJUST SELECTED TIME IF CROSSING MIDNIGHT
    let adjustedSelected = selectedMinutes;
    if (selectedMinutes < fromMinutes) {
      adjustedSelected += 24 * 60;
    }

    return (
      adjustedSelected >= fromMinutes &&
      adjustedSelected <= toMinutes
    );
  });
}

useEffect(()=>{
    // getDoctorsByTime(AllServiceTiming,dateTime.time)
    const result = getDoctorsByTime(AllServiceTiming, dateTime.time);
  setChooseDoctor(result);
  
},[dateTime.time])








  // complete service Timing api 
  console.log("AllServiceTiming datetimestep====>",AllServiceTiming);
  // console.log("departmentWiseServices=============> datetime",departmentWiseServices);
    console.log("selectedServicesData======> in DATE_TIME_STEP",selectedServicesData);
    console.log("timeSlots======>",timeSlots);
      console.log("ChooseDoctor====>",chooseDoctor);



    

  


  

  return (
    <div className="step-content">
      {/* show center */}
      {seletedBranchList.length > 1 ? (
        <div>
          <h3 style={{ margin: "0", marginTop: "1rem" }}>Choose Preferable Center</h3>
          <div className="adv-branch-tabs">
            {seletedBranchList.map((center) => (
              <button
                key={center.BranchID}
                className={`center-tab ${selectedCenter?.BranchID === center.BranchID ? "active" : ""}`}
                onClick={() => onCenterChange(center)}
              >
                {center.Branch}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      <h3 className="step-title">Select Date & Time</h3>

      <div className="date-section">
        <h4 className="section-title">Choose Date</h4>
        <div className="date-grid">
          {dates.map((item, index) => (
            <button
              key={index}
              className={`date-btn ${dateTime.date === item.date ? 'selected' : ''}`}
              onClick={() => handleDateChange(item)}
            >
              <div className="day">{item.day}</div>
              <div className="date">{item.date}</div>
            </button>
          ))}
        </div>
      </div>
      <div className="time-section">
        <h4 className="section-title">Choose Time</h4>
        <div className="time-grid">
          {timeSlots.map((time) => (
            <button
              key={time}
              className={`time-btn ${dateTime.time === time ? 'selected' : ''}`}
              onClick={() => handleTimeChange(time)}
            >
              {time}
            </button>
          ))}
        </div>
      </div>

      <div className="step-footer">
        <button className="btn-secondary" onClick={onBack}>
          Back
        </button>
        <button
          className="btn-primary"
          disabled={!dateTime.date || !dateTime.time || (seletedBranchList.length > 1 && !selectedCenter)}
          onClick={() => onNext({ ...dateTime, center: selectedCenter })}
        >
          Continue to Information
        </button>
      </div>
    </div>
  );
};

export default DateTimeStep;